/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactSiteResponseData,
  GetContactSiteResponseDataFromJSON,
  GetContactSiteResponseDataFromJSONTyped,
  GetContactSiteResponseDataToJSON
} from './GetContactSiteResponseData'

/**
 *
 * @export
 * @interface GetContactSiteResponse
 */
export interface GetContactSiteResponse {
  /**
   *
   * @type {number}
   * @memberof GetContactSiteResponse
   */
  status?: number
  /**
   *
   * @type {GetContactSiteResponseData}
   * @memberof GetContactSiteResponse
   */
  data?: GetContactSiteResponseData
}

export function GetContactSiteResponseFromJSON(json: any): GetContactSiteResponse {
  return GetContactSiteResponseFromJSONTyped(json, false)
}

export function GetContactSiteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactSiteResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactSiteResponseDataFromJSON(json['data'])
  }
}

export function GetContactSiteResponseToJSON(value?: GetContactSiteResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactSiteResponseDataToJSON(value.data)
  }
}
